import { BaseViewStore } from 'core/stores';
import { action, makeObservable } from 'mobx';
import _ from 'lodash';

class ReturnedItemsListDetailViewStore extends BaseViewStore {
	data = [];

	constructor(rootStore, props) {
		super(rootStore);
		makeObservable(this);
		this.initialize(props);
	}

	@action.bound
	initialize = props => {
		this.suspend();
		this.tableData = {
			columns: [
				{
					key: 'name',
					title: 'RETURNEDITEMS.PRODUCTNAME',
					selected: true,
					sortable: false,
					width: 500,
					filter: null,
					resizable: false,
				},
				{
					key: 'sku',
					title: 'RETURNEDITEMS.SKU',
					selected: true,
					sortable: false,
					width: 200,
					filter: null,
					resizable: false,
				},
				{
					key: 'quantity',
					title: 'RETURNEDITEMS.QUANTITY',
					selected: true,
					sortable: false,
					width: 200,
					filter: null,
					resizable: false,
				},
			],
		};
		// dataItem is ShipmentInfoReturn object.
		this.prepareDataItems(props.dataItem.returnedItems);
		this.resume();
	};

	@action.bound
	prepareDataItems = returnedItems => {
		_.each(returnedItems, returnedItem => {
			this.data.push({
				name: returnedItem.product.name,
				sku: returnedItem.product.mainSku,
				quantity: returnedItem.quantity,
			});
		});
	};
}

export default ReturnedItemsListDetailViewStore;
